import { useState } from "react";
import "./App.css";
import logo from "./imagens/logo.png";
import ph from "./imagens/pHagua.png";
import bacteria from "./imagens/bacteria.png";
import tratamento from "./imagens/tratamento.png";
import potavel from "./imagens/potavel.png";
import quiz1 from "./imagens/quiz1.png";
import quiz2 from "./imagens/quiz2.png";
import quiz3 from "./imagens/quiz3.png";
import quiz4 from "./imagens/quiz4.png";
import videoEsgoto from "./videos/videoEsgoto.mp4";
import sustentabilidade from "./imagens/Sustentabilidade.png";



function App() {
  const [pagina, setPagina] = useState("home");
  const [faseAtual, setFaseAtual] = useState(0);
const [pontosGame, setPontosGame] = useState(0);
const [fimGame, setFimGame] = useState(false);
  const [minutos, setMinutos] = useState("");
  const [resultado, setResultado] = useState("");
function calcularAgua() {
  const litros = Number(minutos) * 9;



  setResultado(
    `Consumo estimado: ${litros} litros de água 🚿`
  );
}

  // Quiz
  const [indice, setIndice] = useState(0);
  const [pontos, setPontos] = useState(0);
  const [mostrarResultado, setMostrarResultado] = useState(false);





// Página Qualidade da Água
if (pagina === "sobre") {
  return (
    <div className="pagina-interna">
      <h1>💧 Sobre o Projeto</h1>

    <p>
O <strong>Sanear+</strong> é um projeto educacional desenvolvido com o objetivo de conscientizar a população sobre a importância do saneamento básico, da qualidade da água e da sustentabilidade. A iniciativa busca aproximar ciência e sociedade, mostrando como práticas simples e tecnologias acessíveis podem transformar comunidades e promover saúde pública.
</p>

<p>
O projeto foi desenvolvido utilizando <strong>ReactJS</strong> como parte das atividades acadêmicas da graduação em Engenharia de Computadores na Instituição Celso Lisboa. A escolha dessa tecnologia permite criar interfaces interativas e dinâmicas, facilitando a disseminação de informações e o engajamento dos usuários.
</p>

<p>
Além da dimensão tecnológica, o Sanear+ integra conceitos de <strong>física</strong>, <strong>matemática</strong> e <strong>química</strong>, aplicados em simulações, cálculos de eficiência e demonstrações de processos de tratamento de água. Essa abordagem interdisciplinar reforça a importância da engenharia como ferramenta de transformação social.
</p>

<p>
O projeto também promove debates sobre <strong>sustentabilidade</strong>, incentivando práticas de reaproveitamento de recursos, redução de desperdícios e uso consciente da água. Dessa forma, o Sanear+ não apenas educa, mas inspira mudanças de comportamento que contribuem para um futuro mais saudável e equilibrado.
</p>

      <button
        className="botao"
        onClick={() => setPagina("home")}
      >
        ⬅ Voltar
      </button>
    </div>
  );
}
if (pagina === "agua") {
  return (
    <div className="pagina-interna">
      <h1>💧 Qualidade da Água</h1>
      <p>Principais fatores que garantem água potável:</p>

      <div className="info-cards">

        <div className="info-card">
          <img src={ph} alt="pH da água" className="icone-info" />
          <h3>pH adequado</h3>
          <p>
            A água potável deve ter pH equilibrado, geralmente entre 6 e 9,
            garantindo segurança para o consumo.
          </p>
        </div>

        <div className="info-card">
          <img src={bacteria} alt="Bactérias" className="icone-info" />
          <h3>Ausência de bactérias</h3>
          <p>
            A água não deve conter microrganismos nocivos que possam causar
            doenças à população.
          </p>
        </div>

        <div className="info-card">
          <img src={tratamento} alt="Tratamento" className="icone-info" />
          <h3>Tratamento correto</h3>
          <p>
            O tratamento remove impurezas, resíduos e contaminantes antes da
            distribuição.
          </p>
        </div>

        <div className="info-card">
          <img src={potavel} alt="Potável" className="icone-info" />
          <h3>Potabilidade</h3>
          <p>
            Água potável é aquela que pode ser consumida sem riscos à saúde.
          </p>
        </div>

      </div>

      <button className="botao" onClick={() => setPagina("home")}>
        ⬅ Voltar
      </button>
    </div>
  );
}
  // Página Consumo de Água
  if (pagina === "consumo") {
    return (
      <div className="pagina-interna">
        <h1>🚰 Calculadora de Consumo de Água</h1>

        <p>Digite quantos minutos de banho:</p>
<input
  type="number"
  value={minutos}
  onChange={(e) => setMinutos(e.target.value)}
  placeholder="Ex: 10"
/>

<br /><br />

<button className="botao" onClick={calcularAgua}>
  Calcular
</button>

<h2>{resultado}</h2>

        <button
          className="botao"
          onClick={() => {
            setPagina("home");
            setResultado("");
            setMinutos("");
          }}
        >
          ⬅ Voltar
        </button>
      </div>
    );
  }

  // Página Tratamento de Esgoto
if (pagina === "esgoto") {

  const fases = [
    {
      pergunta: "O que deve ser feito com óleo de cozinha usado?",
      opcoes: ["Reciclar", "Jogar na pia"],
      correta: "Reciclar"
    },
    {
      pergunta: "Qual é a primeira etapa do tratamento de esgoto?",
      opcoes: ["Coleta", "Desinfecção"],
      correta: "Coleta"
    },
    {
      pergunta: "Qual processo remove resíduos sólidos?",
      opcoes: ["Gradeamento", "Distribuição"],
      correta: "Gradeamento"
    },
    {
      pergunta: "Qual etapa separa partículas pesadas?",
      opcoes: ["Decantação", "Cloração"],
      correta: "Decantação"
    },
    {
      pergunta: "Qual é a última etapa do tratamento?",
      opcoes: ["Desinfecção", "Coleta"],
      correta: "Desinfecção"
    }
  ];

  function responderGame(opcao) {
    if (opcao === fases[faseAtual].correta) {
      setPontosGame(pontosGame + 20);
    }

    if (faseAtual + 1 < fases.length) {
      setFaseAtual(faseAtual + 1);
    } else {
      setFimGame(true);
    }
  }

  function reiniciarGame() {
    setFaseAtual(0);
    setPontosGame(0);
    setFimGame(false);
  }

  return (
    <div className="pagina-interna">

      <h1>🧪 Tratamento de Esgoto</h1>

      <video
        className="video-esgoto"
        controls
      >
        <source src={videoEsgoto} type="video/mp4" />
      </video>

      <h2>Etapas do Tratamento</h2>

      <ul className="lista">
        <li>1️⃣ Coleta do esgoto</li>
        <li>2️⃣ Remoção de resíduos sólidos</li>
        <li>3️⃣ Decantação</li>
        <li>4️⃣ Tratamento biológico</li>
        <li>5️⃣ Desinfecção e retorno ao meio ambiente</li>
      </ul>

      <hr />

      <h2>🎮 Missão Rio Limpo</h2>

      <div className="barra">
        <div
          className="progresso"
          style={{
            width: `${((faseAtual + 1) / fases.length) * 100}%`
          }}
        ></div>
      </div>

      {!fimGame ? (
        <div className="game-card">

          <h3>{fases[faseAtual].pergunta}</h3>

          {fases[faseAtual].opcoes.map((opcao) => (
            <button
              key={opcao}
              className="botao quiz-botao"
              onClick={() => responderGame(opcao)}
            >
              {opcao}
            </button>
          ))}

          <p>
            Fase {faseAtual + 1} de {fases.length}
          </p>

          <h3>⭐ Pontos: {pontosGame}</h3>

        </div>
      ) : (
        <div className="game-card">

          <h2>🏆 Missão Concluída!</h2>

          <h3>Pontuação Final: {pontosGame}</h3>

          {pontosGame === 100 && (
            <h2>🥇 Mestre do Saneamento</h2>
          )}

          {pontosGame >= 80 && pontosGame < 100 && (
            <h2>🥈 Guardião dos Rios</h2>
          )}

          {pontosGame >= 60 && pontosGame < 80 && (
            <h2>🥉 Operador Ambiental</h2>
          )}

          {pontosGame < 60 && (
            <h2>📚 Continue aprendendo!</h2>
          )}

          <button
            className="botao"
            onClick={reiniciarGame}
          >
            🔄 Jogar Novamente
          </button>

        </div>
        
        
      )}

      <br />

      <button
        className="botao"
        onClick={() => setPagina("home")}
      >
        ⬅ Voltar
      </button>

    </div>
  );
}

 // Página Quiz
if (pagina === "quiz") {
  const perguntas = [
    {
      imagem: quiz1,
      pergunta: "Água deve ter:",
      opcoes: ["Cor turva", "Um bom ph", "Muito cloro"],
      correta: "Um bom ph",
    },
    {
      imagem: quiz2,
      pergunta: "A presença de bactérias na água pode causar:",
      opcoes: ["Doenças", "Mais oxigênio", "Melhor sabor"],
      correta: "Doenças",
    },
    {
      imagem: quiz3,
      pergunta: "Qual etapa remove resíduos sólidos?",
      opcoes: ["Filtração inicial", "Cloração", "Distribuição"],
      correta: "Filtração inicial",
    },
    {
      imagem: quiz4,
      pergunta: "Um banho de 10 minutos consome aproximadamente:",
      opcoes: ["20 litros", "90 litros", "5 litros"],
      correta: "90 litros",
    },
  ];

  function responder(opcao) {
    if (opcao === perguntas[indice].correta) {
      setPontos(pontos + 1);
    }

    if (indice + 1 < perguntas.length) {
      setIndice(indice + 1);
    } else {
      setMostrarResultado(true);
    }
  }

  function reiniciarQuiz() {
    setIndice(0);
    setPontos(0);
    setMostrarResultado(false);
  }

  if (mostrarResultado) {
    return (
      <div className="app">
        <h1>🏆 Resultado Final</h1>
        <h2>Você acertou {pontos} de 4 perguntas!</h2>

        <button className="botao" onClick={reiniciarQuiz}>
          🔄 Jogar novamente
        </button>

        <br /><br />

        <button
          className="botao"
          onClick={() => {
            setPagina("home");
            reiniciarQuiz();
          }}
        >
          ⬅ Voltar
        </button>
      </div>
    );
  }

  return (
    <div className="app">
      <h1>📚 Quiz do Saneamento</h1>

      <img
        src={perguntas[indice].imagem}
        alt="Pergunta"
        className="quiz-img"
      />

      <h2>{perguntas[indice].pergunta}</h2>

      <div className="quiz-opcoes">
        {perguntas[indice].opcoes.map((opcao) => (
          <button
            key={opcao}
            className="botao quiz-botao"
            onClick={() => responder(opcao)}
          >
            {opcao}
          </button>
        ))}
      </div>

      <p>Pergunta {indice + 1} de 4</p>

      <br />

      <button
        className="botao"
        onClick={() => {
          setPagina("home");
          reiniciarQuiz();
        }}
      >
        ⬅ Voltar
      </button>
    </div>
  );
}
if (pagina === "sustentabilidade") {
  return (
    <div className="pagina-interna">

      <div className="sustentabilidade-container">

        <img
          src={sustentabilidade}
          alt="Sustentabilidade"
          className="img-sustentabilidade"
        />

        <div className="texto-sustentabilidade">

          <h1> Sustentabilidade e Economia de Água</h1>

          <p>
            A água é um recurso essencial para a vida. Utilizar esse recurso de
            forma consciente ajuda a preservar o meio ambiente e garantir água
            para as futuras gerações.
          </p>

          <h2>💡 Dicas para economizar água</h2>

          <ul className="lista">
            <li>🚿 Tomar banhos mais rápidos.</li>
            <li>🚰 Fechar a torneira ao escovar os dentes.</li>
            <li>🔧 Consertar vazamentos rapidamente.</li>
            <li>🌱 Reutilizar água sempre que possível.</li>
            <li>🧺 Utilizar máquinas de lavar com carga completa.</li>
          </ul>

          <h2>🌳 Benefícios da economia de água</h2>

          <ul className="lista">
            <li>✅ Redução do desperdício.</li>
            <li>✅ Preservação dos rios e reservatórios.</li>
            <li>✅ Menor impacto ambiental.</li>
            <li>✅ Economia na conta de água.</li>
          </ul>

        </div>

      </div>

      <button
        className="botao"
        onClick={() => setPagina("home")}
      >
        ⬅ Voltar
      </button>

    </div>
  );
}

 // Tela inicial
return (
  
  <div>
    {pagina === "home" && (
    <header className="navbar">
  <img src={logo} alt="Logo Sanear+" className="logo" />

  <nav>
    <span
  onClick={() => setPagina("sobre")}
  className="link"
>
  Sobre
</span>
    <span onClick={() => setPagina("home")} className="link">Lar</span>
    <span onClick={() => setPagina("agua")} className="link">Água</span>
    <span onClick={() => setPagina("consumo")} className="link">Consumo</span>
    <span onClick={() => setPagina("esgoto")} className="link">Esgoto</span>
    <span onClick={() => setPagina("quiz")} className="link">Questionário</span>
    <span onClick={() => setPagina("sustentabilidade")} className="link">
  Sustentabilidade
</span>
  </nav>
</header>
    )}

 <div className="home">
  

      <div className="cards">
        <div className="card" onClick={() => setPagina("agua")}>
          💧 Qualidade da Água
        </div>

        <div className="card" onClick={() => setPagina("consumo")}>
          🚰 Consumo de Água
        </div>

        <div className="card" onClick={() => setPagina("esgoto")}>
          🧪 Tratamento de Esgoto
        </div>

        <div className="card" onClick={() => setPagina("quiz")}>
          📚 Quiz

        </div>
        <div className="card" onClick={() => setPagina("sustentabilidade")}>
  🌎 Sustentabilidade
</div>

      </div>
    </div>
     <footer className="footer">
      <p>💧 Sanear+ | Projeto de extensão Celso Lisboa sobre Saneamento Básico</p>
      <p>Desenvolvido por Paula Cordeiro - matrícula: 24122157 • Engenharia de Computadores</p>
    </footer>
    
  </div>
  
);

}

export default App;